// extracted by mini-css-extract-plugin
module.exports = {"cta_columns":"Home_cta_columns__1qGE5","primary_cta":"Home_primary_cta__3xBhb"};